import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TourService, IStepOption } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-ui-tour',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './ui-tour.component.html',
  styleUrls: ['./ui-tour.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UiTourComponent {
  @Input() step!: IStepOption & { arrowPosition?: string };
  @Input() tourService!: TourService | null;
}
